import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function DirectionSnackbar({ name, ...pros }) {

  return (
    <div>
      <Snackbar open={pros.open} autoHideDuration={6000}>
        <Alert severity={pros.severity} sx={{ width: '100%' }}>
          {pros.messenger}
        </Alert>
      </Snackbar>
    </div>
  );
}
